import { RBHBox } from "../../../../shared/components"
import React from 'react'
import { MenuDiscount } from "../../../../shared/models/food-menu"
import { TagOutlined } from '@ant-design/icons';
import moment from "moment"
import styles from './styles'

interface props {
    shouldDisplay: boolean;
    menus: MenuDiscount[]
}
export const MenuDiscountLabel = ({shouldDisplay, menus}: props) => {
    if (!shouldDisplay || !Array.isArray(menus) || menus.length === 0) {
        return <></>
    }

    const menu = menus[0]
    const price = ` ฿${menu.priceDiscount}`
    const startDate = ` เริ่ม ${moment(menu.startDate).format('DD/MM/YYYY HH:mm')}`
    const endDate = menu.endDate ? ` สิ้นสุด ${moment(menu.endDate).format('DD/MM/YYYY HH:mm')}` : ''
    return (
        <RBHBox style={styles.menuDiscountLabel}>
            <TagOutlined style={styles.tagIcon} translate={null} />
            <span>{price}</span>
            <span>{startDate}</span>
            <span>{endDate}</span>
        </RBHBox>
    )
}